<div class="myPurchase-dialog-container">
    <div class="myPurchase-dialog-header">
        Reassign RFQ Summary
    </div>
    <div class="myPurchase-dialog-content">
        <div *ngIf="!isReassignCompLoading">
            <div
                *ngIf="userRoleOnRfqSummary === RFQSummaryRole.Assigned_PE || userRoleOnRfqSummary === RFQSummaryRole.Both_PE_RO || userRoleOnRfqSummary === RFQSummaryRole.Other_PE">
                <p>The Assigned PE will be updated to your selection. Related worklist item will also be reassigned on
                    PE
                    Worklist.</p>
                <div class="reassign-dialog-pe">
                    <span>Assigned PE Name</span>
                    <ng-select class="dropdown" [items]="PEDropDown" bindLabel="value" appearance="outline"
                        [appendTo]="'body'" (change)="onPESelected($event)" dropdownPosition="bottom"
                        [(ngModel)]="selectedPE">
                    </ng-select>
                </div>
            </div>
            <div class="reassign-dialog-ro"
                *ngIf="userRoleOnRfqSummary === RFQSummaryRole.Assigned_PE ||userRoleOnRfqSummary === RFQSummaryRole.RO || userRoleOnRfqSummary === RFQSummaryRole.Both_PE_RO">
                <p>The Requesting Officer will be updated to your selection. Related worklist item will also be
                    reassigned on My
                    Worklist.</p>
                <span>Assigned RO Name</span>
                <ng-select class="dropdown" [items]="RODropDown" bindLabel="value" appearance="outline"
                    [appendTo]="'body'" (change)="onROSelected($event)" dropdownPosition="bottom"
                    [(ngModel)]="selectedRO">
                </ng-select>
            </div>
        </div>
        <app-loader [isLoading]="isReassignCompLoading" [message]="loadingMessage"></app-loader>
    </div>
    <div class="myPurchase-dialog-actions">
        <div mat-dialog-actions>
            <app-button class="padBtn mar-r-10" mat-dialog-close [name]="'Cancel'"></app-button>
            <app-button class="padBtn mar-r-10" (click)="onReassign()" [name]="'Reassign'"
                type="flat-button"></app-button>
        </div>
    </div>
</div>